require('./dom');
require('./string');

if (typeof globalThis == 'undefined') {
  window.globalThis = window;
}
